const endpoints = {
  sso: {
    auth: '/auth',
    logout: '/clear-session',
    checkAuth: '/check-session',
  },
  auth: {
    getUser: '/auth/user',
    getListUser: '/auth/users',
  },
  announcement: {
    getAnnouncements: '/announcements',
    getAnnouncementDetail: (id: string) => `/announcements/${id}`,
    create: '/announcements',
    update: (id: string) => `/announcements/${id}`,
    delete: (id: string) => `/announcements/${id}`,
    endPost: (id: string) => `/announcements/${id}/end_post`,
    getLog: (id: string) => `/announcements/${id}/log`,
  },
  content: {
    getContents: '/contents',
    createContent: (sectionId: string) => `/contents/${sectionId}`,
    updateContent: (sectionId: string) => `/contents/${sectionId}`,
    deleteSection: (sectionId: string) => `/contents/${sectionId}`,
    createSection: '/contents',
  },
};

export default endpoints;
